import { supportsES6 } from '@/globals/supports-es6';

if (supportsES6() && navigator && navigator.serviceWorker) {
  window.addEventListener('turbo:load', () => {
    navigator.serviceWorker.register('/service-worker.js');
  });
}
